import {
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  LOGOUT_USER,
  LOGIN_START,
  LOGIN_BACKEND_PICKED,
  LOGIN_SELECT_DEFAULT_BACKEND,
  CHANGE_PASSWORD_START,
  CHANGE_PASSWORD_ERROR,
  CHANGE_PASSWORD_SUCCESS,
  PASSWORD_UPDATE_START,
  PASSWORD_UPDATE_ERROR,
  PASSWORD_UPDATE_SUCCESS
} from '../constants/Constants.js';
import jwtDecode from 'jwt-decode';
import api from '../api';
import messages from '../messages';
import settings from '../components/settings';

let strings = messages.getLocalizedStrings();

function getErrorMsg(msgList, path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(msgList[location[0]], location.slice(1));
  }
  return msgList[path];
}

function getErrorMessage(path) {
  if (~path.indexOf('.')) {
    let location = path.split('.');
    return getErrorMsg(strings.error[location[0]], location.slice(1));
  }
  return strings.error[path];
}

export function deleteCookie(name) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

function error(dispatch, text) {
  dispatch({
    type: LOGIN_USER_ERROR,
    text: getErrorMessage(text),
    level: 'error',
    timeout: 3000
  });
}

export function getUser(jwt) {
  return jwtDecode(jwt);
}

export function login(username, password, nextPath, router) {
  return dispatch => {
    dispatch({
      type: LOGIN_START
    });
    api.login(username, password, function(err, res) {
      if (err) {
        if (err.status === 401) {
          error(dispatch, 'login.invalid');
        } else {
          error(dispatch, 'login.error');
        }
      } else {
        let jwt = res.header['x-auth-token'];
        document.cookie = 'jwt=' + jwt;
        try {
          localStorage.access_token_expire_date = new Date().getTime() / 1000 + res.body.expires_in;
          localStorage.refresh_token = res.body.refresh_token;

          loadBackend(jwt, nextPath, router)(dispatch);
        } catch (e) {
          error(dispatch, 'login.error');
        }
        return true;
      }
    });
  };
}

export function loadBackend(jwt, nextPath, router) {
  return dispatch => {
    let user = getUser(jwt);

    let localBackends = [];
    for (let i = 0; i < settings.length; i++) {
      let setting = settings[i];
      for (let b = 0; b < user.backends.length; b++) {
        let backend = user.backends[b];
        if (setting.index === backend) {
          localBackends.push(setting);
        }
      }
    }
    user.backends = localBackends;

    switch (user.backends.length) {
      case 0:
        error(dispatch, 'login.no_products');
        break;

      case 1:
        dispatch({
          type: LOGIN_USER_SUCCESS,
          jwt: jwt,
          user: user
        });
        // lookup corresponding setting
        let b = null;
        for (let i = 0; i < settings.length; i++) {
          let setting = settings[i];
          let backend = user.backends[0];
          if (setting.customer === backend.customer) {
            b = setting;
          }
        }
        selectBackend(b);

        if (router) {
          router.push(nextPath ? nextPath : '/');
        }

        break;

      default:
        dispatch({
          type: LOGIN_USER_SUCCESS,
          jwt: jwt,
          user: user
        });
        //check if user has a default backend
        let defaultConfig = JSON.parse(localStorage.getItem('default_config_' + user.id));
        let defaultBackend = null;
        if (defaultConfig) {
          let b = null;
          for (let i = 0; i < user.backends.length; i++) {
            let ub = user.backends[i];
            if (ub.customer === defaultConfig.customer) {
              defaultBackend = defaultConfig;
            }
          }
        }

        if (defaultBackend) {
          selectBackend(defaultBackend)(dispatch);
          if (router) {
            router.push(nextPath ? nextPath : '/');
          }
        } else if (!api.config) {
          if (router) {
            router.push('/pickWebsite');
          }
        }

        break;
    }
  };
}

export function selectBackend(backend) {
  api.useConfig(backend);
  return dispatch => {
    dispatch({
      type: LOGIN_BACKEND_PICKED,
      backend: backend
    });
  };
}

export function selectDefaultBackend(user, backend) {
  return dispatch => {
    localStorage.setItem('default_config_' + user.id, JSON.stringify(backend));
    dispatch({
      type: LOGIN_SELECT_DEFAULT_BACKEND,
      user: user
    });
  };
}

export function logoutUser() {
  return dispatch => {
    deleteCookie('jwt');
    dispatch({
      type: LOGOUT_USER
    });
  };
}

export function changePassword(email, callback) {
  return dispatch => {
    dispatch({
      type: CHANGE_PASSWORD_START
    });

    api.resetPassword(email, function(err) {
      if (err) {
        if (err.status === 403) {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage('password.change-failed'),
            level: 'error',
            timeout: 5000
          });
        } else if (err.status === 400) {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage('password.user-not-found'),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: CHANGE_PASSWORD_ERROR,
            text: getErrorMessage('password.change-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: CHANGE_PASSWORD_SUCCESS
        });
      }

      callback(err);
    });
  };
}

export function savePassword(id, token, newPassword, callback) {
  return dispatch => {
    dispatch({
      type: PASSWORD_UPDATE_START
    });

    api.savePassword(id, token, newPassword, function(err, res) {
      if (err) {
        if (res.text && getErrorMessage(res.text)) {
          dispatch({
            type: PASSWORD_UPDATE_ERROR,
            text: getErrorMessage(res.text),
            level: 'error',
            timeout: 5000
          });
        } else {
          dispatch({
            type: PASSWORD_UPDATE_ERROR,
            text: getErrorMessage('password.change-failed'),
            level: 'error',
            timeout: 5000
          });
        }
      } else {
        dispatch({
          type: PASSWORD_UPDATE_SUCCESS,
          text: getErrorMessage('password.password-changed'),
          level: 'info',
          timeout: 5000
        });
      }

      callback(err);
    });
  };
}



// WEBPACK FOOTER //
// /src/actioncreators/LoginActions.js